import React from 'react';
import BtnClose from '../Button/BtnClose';

export default function ErrorAlert({ text, onClose }) {
  if (onClose) {
    return (
      <div className="alert-error alert"><BtnClose onClick={onClose} /> {text}</div>
    );
  }
  return (
    <div className="alert-error">{text}</div>
  );
}
